import React from 'react';
import { makeStyles} from '@material-ui/styles';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';

import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import ShoppingBasketIcon from '@material-ui/icons/ShoppingBasket';

import Paper from '@material-ui/core/Paper';

import {priceFormat} from '../hooks/currency'; 
import ItemVariant from './ItemVariant';

const useStyles = makeStyles((theme) => ({
  card: {
    display: 'flex',
    //backgroundColor: 'yellow',
  },

  details: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
   // backgroundColor: 'red',
  },

  title: {
    display: 'flex',
    flexDirection: 'row',
    //backgroundColor: 'blue',
  },
  name: {
    marginLeft: theme.spacing(1),
    marginRight:  theme.spacing(1),
  },
  price: {
    marginLeft:'auto',
    marginRight:  theme.spacing(1),
  },

  description: {
    marginLeft: theme.spacing(1),
    marginRight:  theme.spacing(1),
  },

  endWithImage: {
    margin: theme.spacing(1, 1,2)
  },


  imageItem:{
    width: 100,
    borderWidth: 0,
    borderRadius: 16,
  },

  controls: {
    display: 'flex',
    justifyContent: 'flex-end',
     alignItems: 'center',
    padding: theme.spacing(1),
  },

  cardControl: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1),
    //backgroundColor: 'green',
  },

  paper: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: theme.spacing(2),
   
  },

  counter:{
    alignItems: 'center',
  },

  bascket: {
    alignItems: 'center',
    marginRight:  theme.spacing(1),
    marginLeft:   theme.spacing(1.5),
  },

  bascketItem: {
    display: 'flex',
    justifyContent: 'flex-end',
     alignItems: 'center',
  },

  divider: {
    marginLeft:"110px",
    margin: theme.spacing(1, 2,2,2),
    [theme.breakpoints.up('md')]: {
     margin: theme.spacing(2, 2,3,2)
     },
   },

   dividerNoImage: {
    margin: theme.spacing(1, 2,2,2),
    [theme.breakpoints.up('md')]: {
     margin: theme.spacing(2, 2,3,2)
     },
   },

   variant: {  
    margin: theme.spacing(1),
   },
}));


const hasAdditions = (item)=>{
  return item && item.additions && item.additions.length>0
}



const getOrderItem=(orderList,itemFood)=>{
  let orderItem = orderList.find(element => element.uid===itemFood.uid) 
//  console.log('order: ',orderItem)
  return orderItem; 
}

const getCountItem=(orderList,item)=>{
    const orderItem = getOrderItem(orderList,item)
    var count = 0;  
    if(orderItem){
        count = orderItem.count
    }
    return count; 
}


export default function ItemFood(props) {
  const {orderList, setOrderList, onOrderListChange,onOrderAddItemAdditions} = props; 
  const {item, currency,showCurrency, isTakingOrder} = props; 

  const [counter, setCounter] = React.useState(0);
  const classes = useStyles();
  const price = priceFormat(currency.style,item.price,showCurrency)
  const orderItem = getOrderItem(orderList,item); 

  const isVisiblePrice = (item,strPrice)=>{
    return (strPrice && strPrice !=="") || hasAdditions(item); 
  }

  const handlerOnAddItem=(item)=>{ 
   // console.log('handlerOnAddItem: it needs additions'); 
    
    if(hasAdditions(item)){
      //console.log('handlerOnAddItem: it needs additions',item); 
      if(onOrderAddItemAdditions) onOrderAddItemAdditions(item); 
      return 
    }

    setOrderList(prevOrderList=>
      addItem(prevOrderList,item)
    ); 
  }


  const handlerOnRemoveItem=(item)=>{
    setOrderList(prevOrderList=>
          removeItem(prevOrderList,item)
    ); 
  }


  const addItem=(list,item)=>{
    let itemOrder = list.find(element => element.uid===item.uid);    
    if(!itemOrder){
        itemOrder = {}; 
        itemOrder.uid = item.uid; 
        itemOrder.count=1; 
        itemOrder.name =item.name;
        itemOrder.price = item.price;
        itemOrder.type = item.type; 
        list.push(itemOrder);
    }else{
      const index = list.indexOf(itemOrder); 
      if(index>=0){
          itemOrder.count++;
          list[index]=itemOrder;
      }
    }
    setCounter(itemOrder.count);
    //console.log('order add: ',order);
    onOrderListChange(list,item);
    return list;
  }


  const removeItem=(list,item)=>{
    let itemOrder = list.find(element => element.uid===item.uid);
    if(itemOrder){
      const index = list.indexOf(itemOrder); 
      if(index>=0 && itemOrder.count>0){
          itemOrder.count--;
          setCounter(itemOrder.count)
          if(itemOrder.count==0){
            list.splice(index,1)
          }else {
            list[index]=itemOrder;
          }
      }
    }
   // console.log('order, remove: ',order); 
    onOrderListChange(list); 
    return list; 
  }
 
  const handlerOnRemoveVariant=(item, variant)=>{
    //console.log('handlerOnRemoveVariant',variant);
   
    const listItemsOrder = orderList; 
    let itemOrder = listItemsOrder.find(element => element.uid===item.uid);

    if(!itemOrder || itemOrder.count===0)return 

    if(itemOrder.count===1){
      handlerOnRemoveItem(item); 
      return; 
    }
    //console.log('handlerOnRemoveVariant itemOrder',itemOrder);
    let variantRemove = itemOrder.variants.find(it => it.key=== variant.key); 
    if(!variantRemove){
      console.error('handlerOnRemoveVariant variant no font');
      return;
    }

    const index = itemOrder.variants.indexOf(variantRemove); 
    itemOrder.variants.splice(index,1); 
    itemOrder.count--;
    setCounter(itemOrder.count); 
    
    const indexItem = orderList.indexOf(itemOrder); 
    let newList = [...orderList];
    newList[indexItem]=itemOrder; 
    setOrderList(newList);
    onOrderListChange(newList); 
  }

 
  return (
    <div >
    <Card className={classes.card} elevation={0}>
     {props.showImage && item.image?
     <div>
        <img  className ={classes.imageItem} src={item.image} alt={"image"} />
     </div>
     : ""
     }

      <div className={classes.details}>
        <div>
          <div className={classes.title}>

            <div className={classes.name}>  
                <Typography variant="subtitle1" color="textPrimary">
                    {item.name}
                </Typography>
            </div>

            <div className={classes.price}>  
            <Typography variant="body2" color="textPrimary">
                    {price}
            </Typography>
            </div>
          </div>
        </div>
        <div className={classes.description}>
          <Typography variant="body2" color="textSecondary">
              {item.description}
          </Typography>
        </div>

        { isTakingOrder &&  isVisiblePrice(item,price)  && 
        <div className={classes.controls}>
          <Card  elevation={0} className={classes.cardControl}>

          {getCountItem(orderList,item)>0 ?
          <div className={classes.bascketItem}>
              
            
              { !hasAdditions(item) && 
              <Paper className={classes.paper} elevation={2}>
              <IconButton aria-label="remove"   onClick={(key)=>handlerOnRemoveItem(item)}>
                <RemoveIcon />
              </IconButton>
              </Paper>
              }

              <ShoppingBasketIcon color='accent' className={classes.bascket} />
              <Typography variant="h5"  color="textSecondary" className={classes.counter}>
              {getCountItem(orderList,item)}
              </Typography>

              <Paper className={classes.paper} elevation={2}>
                  <IconButton aria-label="add"  onClick={( )=>handlerOnAddItem(item)}>
                  <AddIcon />
                  </IconButton>
              </Paper>

            </div>
            :
            <div className={classes.bascketItem}>
            <ShoppingBasketIcon  color='disabled' className={classes.bascket}/>
              <Paper className={classes.paper} elevation={2}>
                  <IconButton aria-label="add"   onClick={()=>handlerOnAddItem(item)}>
                  <AddIcon />
                  </IconButton>
              </Paper>
            </div>
          }
          </Card>
        </div>
     }
     </div>

    </Card>


    { orderItem && orderItem.variants &&
        <div>
          {
            orderItem.variants.map((v,index)=>(
              <div className={classes.variant}    key={index}>
                <ItemVariant
                  item = {orderItem}
                  variant={v}
                  currency={currency}
                  showCurrency={showCurrency}
                  onRemoveVariant={handlerOnRemoveVariant}
                />
              </div>
            ))
          }
        </div>
      }

    { props.showImage && item.image ?
      <div  className={classes.divider}> 
      <Divider/>
      </div>
      :
      <div  className={classes.dividerNoImage}> 
      <Divider/>
      </div>
    }

    </div>
  );
}